import * as React from "react";
//import {getProjectTable2} from '../../utils/services/projectService';
import { useState, useContext, useRef } from "react";
import {
  getProjects,
  // deleteProject,
  // editProject,
} from "../../utils/services/projectService";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import config from "../../utils/config";
import Geocode from "react-geocode";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { appCtx } from "../../utils/hooks/appContext";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../actions/snackbarActions";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { Grid } from "@mui/material";
import {
  GridToolbar,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
  getGridNumericOperators,
  getGridStringOperators,
  getGridDateOperators,
} from "@mui/x-data-grid";
import { GridFilterModel } from "@mui/x-data-grid";
import {
  useGridApiRef,
  gridFilterModelSelector,
  useGridApiContext,
} from "@mui/x-data-grid";

import {
  //GridRowModes,
  DataGrid,
  //GridToolbarContainer,
  //GridActionsCellItem,
} from "@mui/x-data-grid";
import { GridApi } from "@mui/x-data-grid";

import { filterContext } from "../../utils/hooks/filterContext";
import { filter } from "d3";
import { ParkRounded } from "@mui/icons-material";
import UsersTable from "../adminPanel/UsersTable";

Geocode.setApiKey(config.google_map_api_key);
Geocode.enableDebug();

const ProjectsTable = React.memo((props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  // const params = useParams();
  const [rows, setRows] = useState([]);
  const [rowModesModel, setRowModesModel] = useState({});
  /* const [filterModel, setFilterModel] = React.useState({
    items: [
      {
        columnField: "name",
        operator: "contains",
        value: "1",
      },
    ],
  });*/

  const { setProjectId } = useContext(appCtx);

  const { filterParameters, setFilterParameters } = useContext(filterContext);
  //const [loading, setLoading] = useState(true);
  const moment = require("moment");
  // const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  //const [items, setItems] = useState([]);
  function CustomToolbar() {
    /* const apiRef = useGridApiContext();
    //setFilteredRows(apiRef.current.state.rows.ids);
    console.log("Toolbar");
    console.log(apiRef.current.state.filter.filterModel.items[0]);
    console.log(apiRef.current.state.rows.ids);

    //const filteredItems = //items.map((item) => {
    const trueFields = Object.keys(
      apiRef.current.state.filter.filteredRowsLookup
    ).filter(
      (key) => apiRef.current.state.filter.filteredRowsLookup[key] === true
    );

    //.map((key) => parseInt(key));

    //  return trueFields;
    //  });
    console.log(trueFields);
    //if (trueFields.length !== 0)
    //setVisibleProjects(trueFields);
    setVisibleProjects(apiRef.current.state.filter.filteredRowsLookup);
    setItems(apiRef.current.state.filter.filterModel.items);*/
    return (
      <GridToolbarContainer
        className="MuiFormControl-root MuiTextField-root css-i44wyl"
        sx={{
          "&.css-17vbkzs-MuiFormControl-root-MuiTextField-root": {
            marginTop: "0px !important",
            backgroundColor: "yellow",
          },
        }}
      >
        <GridToolbarFilterButton />
      </GridToolbarContainer>
    );
  }

  const theme = useTheme();
  /* useEffect(() => {
    console.log("Ucitavanje podataka za tabelu ");
    setLoading(true);
    setRows([]);
    getProjects()
      .then((res) => {
        if (
          res.statusCode >= 200 &&
          res.statusCode < 300 &&
          res.data.length !== 0
        ) {
          setRows(res.data);
        } else setLoading(false);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", t("snackbar.fetchingDataError")));
      });
  }, []);*/

  /*useEffect(() => {
    console.log("Skeleton za tabelu");
    if (rows.length !== 0) setTimeout(setLoading(false), 1000);
  }, [rows]);*/

  const RenderButtonOpen = (id) => {
    return (
      <Button
        onClick={(e) => {
          toProjectInfo(id);
        }}
        sx={{ color: theme.palette.secondary.main }}
      >
        {t("projectTableBtn.open")}
      </Button> //href='/project-item'
    );
  };

  const toProjectInfo = (id) => {
    //const ID = rows.filter((row) => row.id === id ? ID : row.id);
    setProjectId(id.row.id);
    //localStorage.setItem("id", id.row.id);
    window.scrollTo(0, 0);
    navigate("/project-item", {
      state: {
        projectId: id.row.id,
        projectNumber: id.row.projectNumber,
        projectName: id.row.projectName,
        prevLocation: location.pathname,
      },
    });
  };
  console.log(filterParameters);
  useEffect(() => {
    /* var filterIDs = [];
    if (visibleProjects !== undefined && visibleProjects.length !== 0) {
      console.log(visibleProjects);

      visibleProjects.map((item) => {
        console.log(item.id);
        filterIDs.push(item.id.toString());
      });
      console.log(filterIDs);
    }*/
    /* setFilterModel({
      items: [
        {
          columnField: filterParameters.columnField,
          operator: filterParameters.operator,
          operatorValue: filterParameters.operatorValue,
          value: filterParameters.operatorValue,
        },
      ],
    });*/
  }, [filterParameters]);

  const columns = [
    {
      field: "btnOpen",
      headerName: t("projectTableheaderName.open"),
      flex: 1,
      minWidth: 100,
      cellClassName: "actions",
      renderCell: RenderButtonOpen,
      headerClassName: "header-style",
      filterable: false,
    },
    {
      field: "id",
      headerName: t("projectTableheaderName.projectNumber"),
      minWidth: 50,
      flex: 1,
      headerClassName: "header-style",
      filterOperators: getGridStringOperators().filter(
        (operator) =>
          operator.value === "contains" || operator.value === "isAnyOf"
      ),
    },
    {
      field: "name",
      headerName: "Project name",
      flex: 3,
      minWidth: 100,
      editable: true,
      headerClassName: "header-style",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "createdAt",
      headerName: t("projectTableheaderName.createdAt"),
      type: "date",
      flex: 2,
      minWidth: 100,
      headerClassName: "header-style",
      valueGetter: (params) => {
        const localTime = new Date(
          new Date(params.row.createdAt).getTime() - params.row.timeZone * 60000
        );

        return moment(localTime).format("DD/MM/YYYY HH:mm:ss");
      },

      filterOperators: getGridDateOperators().filter(
        (operator) =>
          operator.value === "is" ||
          operator.value === "before" ||
          operator.value === "onOrBefore" ||
          operator.value === "after" ||
          operator.value === "onOrAfter" ||
          operator.value === "not"
      ),
    },
    {
      field: "address",
      headerName: t("projectTableheaderName.address"),
      flex: 4,
      editable: true,
      minWidth: 100,
      headerClassName: "header-style",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "city",
      headerName: t("projectTableheaderName.city"),
      flex: 2,
      editable: true,
      minWidth: 100,
      headerClassName: "header-style",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "country",
      headerName: t("projectTableheaderName.country"),
      flex: 2,
      editable: true,
      minWidth: 100,
      headerClassName: "header-style",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },

    {
      field: "numberOfUnits",
      headerName: t("projectTableheaderName.numberOfUnits"),
      type: "number",
      flex: 1,
      minWidth: 100,
      headerClassName: "header-style",
      // filterOperators: ["!=", "<", ">"],
      filterOperators: getGridNumericOperators().filter(
        (operator) =>
          operator.value === ">" ||
          operator.value === "<" ||
          operator.value === "!=" ||
          operator.value === "="
      ),
    },

    {
      field: "totalPrice",
      headerName: t("projectTableheaderName.totalCosts"),
      type: "number",
      flex: 1,
      headerClassName: "header-style",
      valueFormatter: ({ value }) => `${value.toFixed(2)} €`,
      minWidth: 100,
      filterOperators: getGridNumericOperators().filter(
        (operator) =>
          operator.value === ">" ||
          operator.value === "<" ||
          operator.value === "!=" ||
          operator.value === "="
      ),
    },

    {
      field: "ownerUserId",
      headerName: t("projectTableheaderName.ownerUserId"),
      // type: "number",
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header-style",
      //valueFormatter: ({ value }) => `${value.toFixed(2)} €`,
      minWidth: 160,
      /*filterOperators: getGridNumericOperators().filter(
        (operator) =>
          operator.value === ">" ||
          operator.value === "<" ||
          operator.value === "!=" ||
          operator.value === "="
      ),*/
    },
  ];
  //console.log(filterModel);
  const handleFilterChange = (newFilterModel) => {
    console.log(newFilterModel);
    // setFilterModel(newFilterModel);
    if (newFilterModel.items.length === 0) {
      console.log("Jeste 0");
      setFilterParameters({
        items: [
          {
            columnField: "id",
            operator: "contains",
            operatorValue: "contains",
            value: "",
          },
        ],
      });
    } else {
      setFilterParameters(newFilterModel);
    }
  };
  console.log(filterParameters);
  //const apiRef = useGridApiRef();

  const isFirstRender = useRef(true);
  /*useEffect(() => {
    console.log("poziva se funkcija gore");
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (
      items.length !== 0 &&
      items[0].value !== null &&
      items[0].value !== undefined
    ) {
      console.log(items);

      setTimeout(() => {
        props.refreshDashboardData(
          items[0].columnField,
          items[0].operatorValue,
          items[0].value
        );
      }, 2000);
    }
  }, [items]);*/
  return (
    /* return loading ? (
    <Box sx={{ width: "100%", height: "75vh" }}>
      <Stack
        spacing={1}
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
      </Stack>
    </Box>
  ) : (*/
    <Grid
      container
      sx={{
        height: 500,
        width: "100%",
        "& .actions": {
          color: "text.secondary",
        },
        "& .textPrimary": {
          color: "text.primary",
        },
      }}
    >
      <Grid item xs={12}>
        <DataGrid
          rows={props.projects}
          columns={columns}
          editMode="row"
          rowModesModel={rowModesModel}
          //GridFilterModel={{ items: items }}
          //autoPageSize
          rowsPerPageOptions={[10, 20, 100]}
          /* pageSize={20}
          /*rowsPerPageOptions={[10, 20]}
          initialState={{
            ...rows.initialState,
            pagination: { paginationModel: { pageSize: 10 } },
          }}*/
          // apiRef={apiRef}
          localeText={{
            MuiTablePagination: {
              labelRowsPerPage: t("tableRows.rowsPerPage"),
              labelDisplayedRows: ({ from, to, count }) =>
                `${from} - ${to} ${t("tableRows.of")} ${count}`,
            },
          }}
          components={{
            Toolbar: CustomToolbar,
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                {t("projectitemrevision.noRows")}
              </Stack>
            ),
          }}
          filterModel={filterParameters}
          onFilterModelChange={handleFilterChange}
          componentsProps={{
            toolbar: { setRowModesModel }, //setRows,
            filterPanel: { sx: { maxWidth: "100vw" } },
          }}
          experimentalFeatures={{ newEditingApi: true }}
          sx={{
            ".MuiTablePagination-select": {
              "margin-top": "-3px",
            },
            ".MuiTablePagination-selectIcon": {
              marginTop: "-3px",
            },

            ".MuiFormControl-root.MuiFormControl-marginNormal.MuiFormControl-fullWidth.MuiTextField-root.css-17vbkzs-MuiFormControl-root-MuiTextField-root":
              {
                display: "none",
              },
            ".MuiDataGrid-columnHeaderTitle.css-1jbbcbn-MuiDataGrid-columnHeaderTitle":
              {
                fontWeight: "bold",
                paddingLeft: "5px",
              },
          }}
        />
      </Grid>
    </Grid>
  );
});

ProjectsTable.whyDidYouRender = true;

export default ProjectsTable;
